module.exports = __webpack_public_path__ + "img/transferring.851e0268.png";